import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  qrcodeFrame: {
    padding: '10px',
    backgroundColor: theme.palette.white_100.main
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  qrcodeContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: '10px'
  },
  qrcodeWaiting: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: '10px',
    color: theme.palette.gray_400.main
  },
  qrcodeInfo: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  }
}))
